/**
 * Reducer pro použití jako skupina standardních (např. list nebo detail) reducerů.
 */

import processAreaStores from '../utils/processAreaStores';
import { SharedReducer } from './SharedTypes';

const initialState = {
  reducer: areaGroupReducer
};

const __AGR_INIT = '___AGR_INIT';

export default function areaGroupReducer(
  state: SharedReducer = initialState,
  action: { action?: string; area?: string; type: string; store?: any } = {
    type: __AGR_INIT
  }
) {
  if (action.area) {
    return processAreaStores(state, {
      area: action.area,
      type: action.type,
      store: action.store
    });
  }

  switch (action.type) {
    case __AGR_INIT: {
      return {
        ...initialState,
        ...state
      };
    }
    default:
      return state;
  }
}
